





















































import Career, { ICareer } from '@/models/Career'
import Tag from '@/models/Tag';
import { Component, Emit, Prop } from 'vue-property-decorator'
import User from '@/models/User'
import JobSelector from '@/components/entry/JobSelector.vue'
import FormBase from "@/pages/form-base"
import Tagging, {ITagging} from "@/models/Tagging"

@Component({
  components: {
    JobSelector
  }
})
export default class ChangeJobForm extends FormBase {
  @Prop(Object) readonly value!: User

  @Emit()
  input(value: User): User {
    return value
  }

  get internalValue(): User {
    return this.value
  }

  set internalValue(val: User) {
    this.input(val)
  }

  editSelectedCareers: Array<Tag> = []
  // selectedCareers: Array<Career> = []
  showedCareersSelector = false

  editSelectedHopJobs: Array<Tag> = []
  showedHopeJobsSelector = false

  startEditCareers(): void {
    this.editSelectedCareers = this.internalValue.careers.map(c => c.tag)
    this.showedCareersSelector = true
  }

  startEditHopeCareers(): void {
    this.editSelectedHopJobs = this.internalValue.hope_jobs.map(c => c.tag)
    this.showedHopeJobsSelector = true
  }

  selectCareers(): void {
    this.internalValue.careers = this.editSelectedCareers.map(c => {
      const career = new Career({ years: this.internalValue.careers.find(sc => sc.tag.id === c.id)?.years } as ICareer)
      career.tag = c
      return career
    })
    this.showedCareersSelector = false
  }

  selectHopeJobs(): void {
    this.internalValue.hope_jobs = this.editSelectedHopJobs.map(c => {
      const tagging = new Tagging({ tag_id: c.id } as ITagging)
      tagging.tag = c
      return tagging
    })
    this.showedHopeJobsSelector = false
  }

  public validate(): boolean {
    this.valid = (this.$refs.form as HTMLFormElement).validate()
    this.validated = true
    return this.valid
  }
}
